import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Text, TextType } from 'ui-components/components/text';

import { SellerSettings } from '../../../../../../enums/seller-settings/seller-settings';
import { useModifiableSellerSetting } from '../../../../../../hooks/use-modifiable-seller-setting';
import { useCustomsStoreCurrency } from '../../../../../../hooks/use-seller-setting';
import { requestGetOrders } from '../../../../../../store/orders/orders.actions';
import Global from '../../../../../../store/global-selectors';

import { messages } from './messages';
import styles from './styles.module.css';

export const CustomsStoreCurrencyWarning = () => {
  const dispatch = useDispatch();
  const defaultCurrency = useSelector(Global.selectSellerDefaultCurrency);

  const isCustomsStoreCurrencyEnabled = useCustomsStoreCurrency();
  const [, saveSetting] = useModifiableSellerSetting(SellerSettings.customsStoreCurrency, false);

  const deactivateStoreCurrencyForCustomsForm = useCallback(async () => {
    await saveSetting(false);
    dispatch(requestGetOrders());
  }, [saveSetting, dispatch]);

  if (!isCustomsStoreCurrencyEnabled) {
    return null;
  }

  return (
    <BannerMessageV2
      buttons={
        <Button className={styles['revert-button']} onClick={deactivateStoreCurrencyForCustomsForm} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.storeCurrencyWarningAction} values={{ currency: defaultCurrency }} />
        </Button>
      }
      content={<Text textType={TextType.Caption} value={<FormattedMessage {...messages.storeCurrencyWarning} />} />}
      status={BannerStatus.Warning}
      className={styles.banner}
    />
  );
};
